(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Recharts"] = factory(require("react"), require("prop-types"), require("react-dom"));
	else
		root["Recharts"] = factory(root["React"], root["PropTypes"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__4698__, __WEBPACK_EXTERNAL_MODULE__3409__, __WEBPACK_EXTERNAL_MODULE__6207__) {
return 